import { Injectable } from "@angular/core";

import { TherapeuticClass } from "../pbm/Benefit/therapeutic-class";
import { PagingRequest } from "../paginator/paging-request";
import { TherapeuticClassService } from "../../../services/pbm/therapeutic-class.service";
import { IAutoCompleteItem } from "./iauto-complete-item";
import { IAutoCompleteSearchProvider } from "./iauto-complete-search-provider";
import { TherapeuticClassProductAutoCompleteItem } from "./therapeutic-class-product-auto-complete-item";

@Injectable()
export class TherapeuticClassProductAutoCompleteSearchProvider implements IAutoCompleteSearchProvider {
  constructor(private therapeuticClassProductService: TherapeuticClassService) {}

  async search(filter: string): Promise<IAutoCompleteItem[]> {
    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(0);
    pagingRequest.setEnd(10);
    pagingRequest.setFilterText(filter);

    const pageableResult = await this.therapeuticClassProductService.searchTherapeuticClassProductsBy(pagingRequest);

    return pageableResult.getItems().map((terapheuticClassItem: TherapeuticClass) => new TherapeuticClassProductAutoCompleteItem(terapheuticClassItem));
  }
}
